import React, { ReactNode } from 'react';
import ClockIcon from 'icons/Clock.icon';
import SettingsIcon from 'icons/Settings.icon';

export const MEMBER_DRAWER_OPTIONS = {
  SETTINGS: 'settings',
  ACTIVITY: 'activity',
} as const;

export type MemberDrawerOption =
  typeof MEMBER_DRAWER_OPTIONS[keyof typeof MEMBER_DRAWER_OPTIONS];

export const drawerNavigationTabs: Record<
  MemberDrawerOption,
  { icon: ReactNode; value: MemberDrawerOption }
> = {
  [MEMBER_DRAWER_OPTIONS.SETTINGS]: {
    icon: <SettingsIcon />,
    value: MEMBER_DRAWER_OPTIONS.SETTINGS,
  },
  [MEMBER_DRAWER_OPTIONS.ACTIVITY]: {
    icon: <ClockIcon />,
    value: MEMBER_DRAWER_OPTIONS.ACTIVITY,
  },
};
